import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ShieldCheck, Star, Users, Check } from "lucide-react";
import { toast } from "sonner";

export default function Subscribe() {
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        origin_url: window.location.origin,
        plan: "monthly",
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      setBusy(false);
    }
  };

  return (
    <div className="container-x py-20 max-w-3xl" data-testid="subscribe-page">
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#CC5A3A] mb-3">For collectors</div>
      <h1 className="font-heading text-4xl text-[#1E3F33] font-semibold">Go Pro on <span className="text-[#B91C1C]">Screening Services Mobile</span></h1>
      <p className="text-[#5C6B64] mt-3 max-w-xl">Get access to customer requests, build trust with a certified badge, and grow your collection business.</p>

      <div className="card-soft mt-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="text-xs uppercase tracking-wider text-[#8A9A86]">Pro plan</div>
            <div className="font-heading text-4xl text-[#1E3F33] mt-1">$10.99<span className="text-lg text-[#8A9A86]">/month</span></div>
            <div className="text-sm text-[#5C6B64] mt-1">Cancel anytime.</div>
          </div>
          <button data-testid="subscribe-button" onClick={start} disabled={busy} className="btn-accent">
            {busy ? "Redirecting…" : "Subscribe with Stripe"}
          </button>
        </div>

        <ul className="mt-8 space-y-3">
          {[
            { icon: ShieldCheck, t: "Certified Pro badge on your profile" },
            { icon: Users, t: "Receive unlimited customer booking requests" },
            { icon: Star, t: "Higher visibility in search results" },
            { icon: Check, t: "Unlimited certification document uploads" },
          ].map((f, i) => (
            <li key={i} className="flex items-center gap-3 text-[#1E3F33]">
              <f.icon className="w-5 h-5 text-[#2D6A4F]" strokeWidth={1.6}/>
              <span>{f.t}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
